/**
 * Get series from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

export const calendarGQLQuery = (path) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500

  return gql(`{
    RootsTechPageEntry(id: "${path}") {
      ... on Calendar {
        title
        stages {
          calendarItems {
            date {
              timestamp
            }
            item {
              title
              type
              url
              description
              category
              collectionCount
              contentUUID
              creators {
                profilePhoto {
                  custom(height: ${imageSize}, width: ${imageSize}) {
                    image {
                      src
                      }
                    }
                }
                name
              }
            }
          }
        }
      }
    }
  }
  `)
}

export const dummy = () => {}
